export const images = [
  {
    id: '01',
    src: '/Logan Land 01.jpg',
    alt: 'Logan Land',
  },
  {
    id: '02',
    src: '/Logan Land 02.jpg',
    alt: 'Logan Land',
  },
  {
    id: '03',
    src: '/Logan Land 03.jpg',
    alt: 'Logan Land',
  },
  {
    id: '04',
    src: '/Logan Land 04.jpg',
    alt: 'Logan Land',
  },
  {
    id: '05',
    src: '/Logan Land 05.jpg',
    alt: 'Logan Land',
  },
  {
    id: '06',
    src: '/Logan Land 06.jpg',
    alt: 'Logan Land',
  },
  {
    id: '07',
    src: '/Logan Land 07.jpg',
    alt: 'Logan Land',
  },
]
